/* eslint-disable react-hooks/exhaustive-deps */
import ShortAccess from "common/components/ShortAccess"
import { OCR_MESSAGE_ACCESS_SHORT } from "common/constants/ocrMessages"
import { clearLibrado } from "features/Crear/redux/slices/newDocumentoSlice"
import { AnimatePresence, motion } from "framer-motion"
import { useDispatch } from "hooks/useDispatch"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import CloseButtonComponent from "./components/CloseButtonComponent"
import { DocumentCreation } from "./components/DocumentCreation"
import SectionComponent from "./components/SectionComponent"
import { CREATE_DOCUMENT_SECTION, directAccessCreationPaths } from "./constant"

const DirectAccess = ({
  setShowMenuNuevosDocumentos,
  showMenuNuevosDocumentos,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const [actionsFilter, setActionsFilter] = useState("")
  const [actionsOptions, setActionsOptions] = useState(
    directAccessCreationPaths(t)
  )

  const handleFilterActions = (event: $TSMigrationFixMe) => {
    const { value } = event.target
    const options = directAccessCreationPaths(t).map((option) => ({
      ...option,
      subMenu: option.subMenu.filter(({ text }) =>
        text.toLowerCase().trim().includes(value?.toLowerCase().trim())
      ),
    }))
    setActionsFilter(value)
    setActionsOptions(options)
  }

  const handleClick = async (path: $TSMigrationFixMe) => {
    if (path !== window.location.pathname) await dispatch(clearLibrado())
    setShowMenuNuevosDocumentos(!showMenuNuevosDocumentos)
    setActionsFilter("")
    setActionsOptions(directAccessCreationPaths(t))
    if (path) history.push(path)
  }

  return (
    <AnimatePresence>
      {showMenuNuevosDocumentos && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className='nuevos-documentos d-flex flex-column w-100'
        >
          <div className='close-button-container'>
            <CloseButtonComponent
              handleClick={() =>
                setShowMenuNuevosDocumentos(!showMenuNuevosDocumentos)
              }
            />
          </div>
          <div className='pt-5 my-auto d-flex flex-column align-items-center'>
            <div className='mt-5'>
              <div className='tw-flex tw-justify-between tw-items-end'>
                <span className='tw-text-left tw-text-alternative'>
                  {t("nav.directAccess.emisionDocLabel")}
                </span>
              </div>
              <div className='tw-flex tw-flex-row tw-justify-center tw-gap-2 tw-pt-4'>
                {CREATE_DOCUMENT_SECTION(t).map((menu) =>
                  DocumentCreation({
                    key: menu.key,
                    handleOnClick: handleClick,
                    sub: menu,
                  })
                )}
              </div>
            </div>

            <SectionComponent
              key='create-section'
              items={actionsOptions}
              value={actionsFilter}
              documentIsReady={showMenuNuevosDocumentos}
              handleFilter={handleFilterActions}
              handleClick={handleClick}
            />
            <ShortAccess
              body={OCR_MESSAGE_ACCESS_SHORT(t)}
              close={handleClick}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default DirectAccess
